import { render, staticRenderFns } from "./UpgradeManagement.vue?vue&type=template&id=3629e3d8&scoped=true&"
import script from "./UpgradeManagement.vue?vue&type=script&lang=js&"
export * from "./UpgradeManagement.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeManagement.vue?vue&type=style&index=0&id=3629e3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629e3d8",
  null
  
)

export default component.exports